import * as Sentry from '@sentry/react'

export const sentryCaptureMessage = (meesage = '') => {
  if (process.env.NODE_ENV !== 'development') {
    Sentry.captureMessage(meesage)
  }
}
